var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"container is-fluid"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"}),_vm._v(" "),_c('div',{staticClass:"column has-text-right"},[_c('span',{staticClass:"is-size-7",domProps:{"innerHTML":_vm._s(_vm.copyright)}}),_vm._v(", \n                "),_c('span',{staticClass:"is-size-7",domProps:{"innerHTML":_vm._s(_vm.techstack)}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77dbb4d7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landing_footer.vue
// module id = 600
// module chunks = 0